// Tema "oficina": tema por defecto de la supervisión visual (Fase 9.2).
const oficina = {
  id: 'oficina',
  rooms: {
    control: { label: 'Coordinación', hint: 'El orquestador reparte el trabajo' },
    booths: { label: 'Puestos de IA', hint: 'Un agente de IA por puesto' },
    humans: { label: 'Oficina de asesores', hint: 'Un puesto por asesor' },
    lobby: { label: 'Recepción', hint: 'Casos esperando asesor' },
  },
  words: {
    onAir: 'ACTIVO',
    clip: 'ERROR',
    patchbay: 'Conexiones',
    patchbayHint: 'Integraciones de la oficina',
    station: 'puesto',
  },
  station: 'desk',         // escritorio con pantalla
  control: 'desk',         // mesa de coordinación
  decor: 'windows',        // ventanas en las paredes
  colors: {
    bg: '#0b1018',
    floor: '#172131',
    floorLine: 'rgba(255,255,255,0.04)',
    wallBack: '#233047',
    wallSide: '#1c273a',
    wallRim: '#34455f',
    panel: '#2c4a6b',
    panelAlt: '#27425f',
    furniture: '#3a4a60',
    furnitureTop: '#51647f',
    furnitureSide: '#2c394b',
    screen: '#0b1220',
    screenGlow: '#38bdf8',
    glass: 'rgba(56,189,248,0.08)',
    glassEdge: 'rgba(125,211,252,0.3)',
    accent: '#38bdf8',
    ai: '#0ea5e9',
    aiSkin: '#7dd3fc',
    lead: '#94a3b8',
    human: { online: '#22c55e', paused: '#f59e0b', offline: '#475569' },
    skin: '#e7c9a9',
    onAir: '#22c55e',
    onAirOff: '#1d3325',
    clip: '#f43f5e',
    case: '#fbbf24',
    text: '#e2e8f0',
    muted: '#94a3b8',
    halo: '#0b1018',
    cardBg: 'rgba(12,18,28,0.92)',
    cardBorder: 'rgba(56,189,248,0.35)',
    rack: '#121a26',
    rackEdge: '#263447',
    cable: { up: '#22c55e', down: '#ef4444', not_configured: '#475569', unknown: '#64748b' },
    vu: ['#22c55e', '#22c55e', '#22c55e', '#84cc16', '#eab308', '#f97316', '#ef4444'],
  },
};

export default oficina;
